<template>
    <div v-if="chartData.length != undefined && chartData.length > 0 && chartData.length != null">
        <GChart type="PieChart" :data="chartData" :options="chartOptions" style="margin-left:300px"/>
    </div>
    <div v-else>
        <span>No data Found</span>
    </div>
</template>


<script>
import Vue from "vue";


import WorkOrderList from "@/components/WorkOrderList.vue";
Vue.component("work-order-list", WorkOrderList);
import customerCreditRequest from '@/components/CustomerCreditRequest';
Vue.component("app-customer-credit-request",customerCreditRequest);
import { GChart } from 'vue-google-charts/legacy';

export default ({
    components: {
        GChart
    },
    props: {
        fromModule: {
            type: Object,
            required: false,
            default: undefined
        },
    },
    watch:{
        location_id(val){
            var self = this;
            self.locationId = val.value;
            if(val != null){
                self.getchartdata();
            }
        }
    },
    data: () => ({
        location_error_msg: "",
        location_id: null,
        locationArr: [],
        chartData: [],  
        chartOptions: {
          title: 'Asset Analytics',
          width: 800,
          height: 600,
        },
        locationId:0
    }),
    mounted: function() {
        var self = this;
        setTimeout(function () {
            self.getchartdata();
        }, 1000);
        
    },
    methods: {
        getchartdata(){
            var self = this;
            self.loading = true;
            
            if(self.fromModule!=null && self.fromModule!=undefined){
                self.locationId = self.fromModule.value;
            }
            $.ajax({
                    url: process.env.ROOT_API + "/assetchart",
                    type: "get",
                    headers: this.ajxHeaders,
                    data:{
                        location_id: self.locationId,
                    },
                    crossDomain: true,
                    success: function (data) {
                        self.chartData = data.content;
                        self.loading = false;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,true,'credit-businesstype');

                    }
                });
        },
    }
})
</script>



// WEBPACK FOOTER //
// src/components/dashboard/AssetAnalytics.vue